// extracted by mini-css-extract-plugin
module.exports = {"Downloads":"Downloads_Downloads__190oT"};